<template>
    <div>
        <BotpressChat />
    </div>
</template>

<script>

import BotpressChat from './includes/botpress/BotpressChat.vue';  

export default {
    components: { BotpressChat }
};
</script>
